import { Box } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../../utils/datahooks';
import { wdsThemeColors } from '../../../../utils/wds-theme-colors';
const cardBorderColorVar = '--collapse-list-card-border-color';

/**
 * Creates the visual effect of rounded bottom corners for a sticky header.
 *
 * This is necessary because `overflow: hidden` (which would normally clip children
 * to rounded corners) breaks `position: sticky`. Instead, we overlay:
 *
 * 1. Two radial gradients that "cut out" quarter circles at the bottom corners
 * 2. A border overlay with rounded bottom corners
 *
 * Together, these create the illusion of a card with rounded bottom corners.
 */
export const StickyHeaderRoundedCorners = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
  background: `
        radial-gradient(circle at 8px 0px, transparent 8px, ${wdsThemeColors.surfaceTertiary} 8px) left,
        radial-gradient(circle at 0px 0px, transparent 8px, ${wdsThemeColors.surfaceTertiary} 8px) right
      `,
  backgroundRepeat: "no-repeat",
  backgroundSize: "8px 8px",
  bottom: 0,
  dataHook: dataHooks.stickyHeaderRoundedCorners,
  height: 8,
  left: 0,
  pointerEvents: "none",
  position: "absolute",
  right: 0,
  zIndex: 4
}), /*#__PURE__*/React.createElement(Box, {
  borderRadius: "0 0 8px 8px",
  bottom: 0,
  left: 0,
  pointerEvents: "none",
  position: "absolute",
  right: 0,
  style: {
    borderBottom: `1px solid var(${cardBorderColorVar})`,
    [cardBorderColorVar]: wdsThemeColors.borderDarkSecondary
  },
  top: 0,
  zIndex: 3
}));
//# sourceMappingURL=sticky-header-rounded-corners.js.map